import { Wizard } from '@lounge-fe/ui-kit'
import { useFormContext } from 'react-hook-form'
import { useTranslation } from 'react-i18next'
import { StepActionsProps } from '../types'

export const StepActions = ({ next = true, back = true }: StepActionsProps) => {
  const { t } = useTranslation()
  const {
    formState: { isValid },
  } = useFormContext()

  return (
    <div className="flex justify-between my-6">
      {Boolean(back) && (
        <Wizard.Back size="lg">
          {typeof back === 'object' && back.label
            ? back.label
            : t('action.back')}
        </Wizard.Back>
      )}
      {Boolean(next) && (
        <Wizard.Next
          disabled={!isValid}
          onClick={
            typeof next === 'object' && next.onClick ? next.onClick : undefined
          }
          size="lg"
        >
          {typeof next === 'object' && next.label
            ? next.label
            : t('action.next')}
        </Wizard.Next>
      )}
    </div>
  )
}
